import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useGenerateWriteOffReport = () => {
  return useMutation({
    mutationFn: async (batchId: string) => {
      const result = await apiClient.batchesReports.generateWriteOffReport.mutation({ params: { id: batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      toast.success('Write-off report generation started!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating write-off report!');
    },
  });
};
